import uploadManagement from '@/vuepage/upload/index';

import uploadPage from '../vuepage/upload/upload';

export default [
  {
    path: '/upload-management',
    component: uploadManagement,
    children: [
      {
        path: 'upload-page',
        component: uploadPage,
        meta: [
          {
            name: '北美七牛',
            url: '/upload-management',
          },
          {
            name: '批量上传图片',
            url: 'upload-page',
          },
        ],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/upload.js